<template>
  <b-flip-modal @close="close">
    <div slot="modal-body" :class="['row', 'center-xs', 'modal-wrapper-box']">
      <div class="modal-container">
        <div class="modal-header">
          <span class="com-title">{{ title }}</span>
        </div>
        <div v-if="error" class="error">{{ error }}</div>
        <div id="errorContainer">
          <div v-if="getErrors" class="error">{{ getErrors('updateError') }}</div>
        </div>
        <div class="modal-body">
          <form>
            <div class="form-group">
              <div id="errorContainer">
                <div v-if="getErrors" class="error">{{ getErrors('name') }}</div>
              </div>
              <label for="name">Advertiser Name<span class="required">*</span></label>
              <input
                id="name"
                ref="nameInput"
                v-model="advertiser.name"
                type="text"
                aria-describedby="emailHelp"
                @input="validateName"
              />
              <div v-if="matchingAdvertisers.length > 0" class="advertiser-matches">
                <ul class="dropdown dropdown-menu">
                  <li v-for="(match, index) in matchingAdvertisers" :key="index">
                    {{ match.name }}
                  </li>
                </ul>
              </div>
            </div>
            <div class="form-group dsp-row-override">
              <div class="dsp-error-container">
                <div v-if="getErrors('dspMandatoryForPixel')" class="error">
                  {{ getErrors('dspMandatoryForPixel') }}
                </div>
                <div
                  v-if="!getErrors('dspMandatoryForPixel') && getErrors('xandrId')"
                  class="error"
                >
                  {{ getErrors('xandrId') }}
                </div>
                <div
                  v-if="!getErrors('dspMandatoryForPixel') && getErrors('yahooId')"
                  class="error"
                >
                  {{ getErrors('yahooId') }}
                </div>
              </div>

              <label for="xandrId">Xandr DSP ID</label>

              <div class="dsp-fields-container">
                <input
                  id="xandrId"
                  ref="xandrIdInput"
                  v-model="advertiser.dspMappings.XANDR"
                  type="text"
                  class="dsp-input"
                  @input="validateAdvertiserXandrId"
                />

                <label for="yahooId" class="yahoo-inline-label">Yahoo DSP ID</label>

                <input
                  id="yahooId"
                  ref="yahooIdInput"
                  v-model="advertiser.dspMappings.YAHOO"
                  type="text"
                  class="dsp-input"
                  @input="validateAdvertiserYahooId"
                />
              </div>
            </div>

            <div v-if="bothDspsEntered && isAuthorizedDspUser" class="form-group dsp-toggle-group">
              <label>Default DSP</label>

              <div id="defaultDsp" class="toggle-container-wrapper">
                <div class="toggle-container">
                  <div
                    class="toggle-btn"
                    :class="{ active: advertiser.dsp === 'XANDR' }"
                    @click="setDefaultDsp('XANDR')"
                  >
                    Xandr
                  </div>
                  <div
                    class="toggle-btn"
                    :class="{ active: advertiser.dsp === 'YAHOO' }"
                    @click="setDefaultDsp('YAHOO')"
                  >
                    Yahoo
                  </div>
                </div>
              </div>
            </div>
            <div class="form-group">
              <div id="errorContainer">
                <div v-if="getErrors" class="error">{{ getErrors('vertical') }}</div>
              </div>
              <div class="lg-control-box">
                <label for="vertical">Vertical <span class="required">*</span></label>
                <k-select
                  ref="vertical"
                  v-model="advertiser.vertical"
                  :options="sortedVerticalOptions"
                  label-key="name"
                  :multiple="false"
                  :value="selectedVertical"
                  :searchable="true"
                  :show-clear-selection-btn="false"
                  label="Please select vertical"
                  :class="[isVerticalAlert ? '' : 'errorBox']"
                  @input="onVerticalSelect"
                />
              </div>
            </div>
            <div class="form-group">
              <div class="lg-control-box">
                <label for="features">Features</label>
                <k-select
                  ref="featuresList"
                  name="features"
                  label-key="name"
                  label="Features"
                  :multiple="true"
                  :class="[]"
                  :fancy="true"
                  :options="featuresListOptions"
                  :close-on-select="false"
                  :value="selectedFeatures"
                  @input="onSelectFeatures"
                />
              </div>
            </div>
            <div class="form-group form-check">
              <label class="form-check-label" for="hideCostMetrics">Hide Cost Metrics</label>
              <k-checkbox
                id="hideCostMetrics"
                :checked="advertiser.hideCostMetrics"
                name="advertiser.hideCostMetrics"
                @change="setHideCostMetrics"
                @selected="setHideCostMetrics"
              />
            </div>
            <div class="form-group form-check">
              <label class="form-check-label" for="customReportsEnabled">Custom Reports</label>
              <k-checkbox
                id="customReportsEnabled"
                :checked="advertiser.customReportsEnabled"
                name="advertiser.customReportsEnabled"
                @change="setCustomReportsEnabled"
                @selected="setCustomReportsEnabled"
              />
            </div>
            <div class="form-group">
              <div id="errorContainer">
                <div v-if="getErrors" class="error">{{ getErrors('website') }}</div>
              </div>
              <label for="website">Website</label>
              <input
                id="website"
                ref="websiteInput"
                v-model="advertiser.website"
                :style="advertiser.website === 'https://' ? 'opacity: 50%' : ''"
                type="text"
                @input="validateWebsite"
              />
            </div>
            <div class="form-group">
              <div id="errorContainer">
                <div v-if="getErrors" class="error">{{ getErrors('about') }}</div>
              </div>
              <label for="about">About</label>
              <textarea
                id="about"
                v-model="advertiser.about"
                rows="5"
                maxLength="1500"
                placeholder=""
              ></textarea>
            </div>
            <div v-if="false" class="form-group form-check long-label">
              <label for="userlogin">&nbsp;</label>
              <k-checkbox
                :checked="createAdvertiserOrg"
                name="add.org"
                label="Enable user login?"
                @change="setCreateAdvertiserOrg"
                @selected="setCreateAdvertiserOrg"
              />
            </div>
            <br />
            <div class="form-group" style="text-align: right; float:right; display: contents;">
              <div class="actions-btn">
                <k-button :size="3" label="SAVE" class="mr-20" @click="handleAdvertiser" />
                <k-button :size="3" label="CLOSE" @click="close" />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </b-flip-modal>
</template>

<script>
import { get } from 'vuex-pathify';
import { isEqual } from 'lodash';
import { isBlank } from 'adready-api/helpers/common';
import organizationApi from 'adready-api/api/organization';
import { PRIVILEGE_TO_CREATE, E_ORGANIZATION } from 'adready-api/auth-constant';
import { DSP, VERTICALS, REACH_AND_FREQ_DASHBOARD } from '@/constant';
import flipPixelApi from '~/api/flipPixel';
import { buildQueryString } from '~/helpers/global/url-helpers';
import advertiserApi from '~/api/advertiser';
import forklift from '~/components/mixins/forklift-mixin';
import authzMixin from '~/components/mixins/authz-mixin';
import { loadAllFeatures, getAuthorizedDspUserList } from '~/util/utility-functions';

export default {
  components: {
    BFlipModal: () =>
      import(/* webpackChunkName: "b-flip-modal" */ '~/components/elements/b-flip-modal.vue'),
  },
  mixins: [forklift, authzMixin],
  props: {
    accountId: {
      type: Number,
      required: false,
      default: 0,
    },
    accountRef: {
      required: false,
      default: null,
      type: Object,
    },
    initialAdvertiser: {
      required: true,
      default() {
        return {};
      },
      type: Object,
    },
    advertiserLoading: {
      required: false,
      default: false,
      type: Boolean,
    },
  },
  data() {
    const advertiser = JSON.parse(JSON.stringify(this.initialAdvertiser)) || {};

    // Ensure `dspMappings` exists so `v-model` bindings to
    // `advertiser.dspMappings.XANDR` / `advertiser.dspMappings.YAHOO`
    // won't throw (undefined) or become non-reactive in Vue 2.
    if (!advertiser.dspMappings || typeof advertiser.dspMappings !== 'object') {
      advertiser.dspMappings = { XANDR: null, YAHOO: null };
    } else {
      if (advertiser.dspMappings.XANDR === undefined) advertiser.dspMappings.XANDR = null;
      if (advertiser.dspMappings.YAHOO === undefined) advertiser.dspMappings.YAHOO = null;
    }

    if (advertiser.dsp === undefined) advertiser.dsp = null;

    if (!advertiser.website) {
      advertiser.website = 'https://';
    }
    const existingAccount = JSON.parse(JSON.stringify(this.accountRef));
    const verticalOptions = [...VERTICALS];
    const dsp = [...DSP];
    const selectedVertical = null;
    const selectedDsp = null;
    const featuresListOptions = [];
    return {
      selectedVertical,
      selectedDsp,
      dsp,
      verticalOptions,
      advertiser,
      isVerticalAlert: true,
      accountData: existingAccount || {},
      createAdvertiserOrg: false,
      loading: false,
      errorMsg: null,
      errors: [],
      E_ORGANIZATION,
      PRIVILEGE_TO_CREATE,
      featuresListOptions,
      advertiserPixelList: [],
    };
  },
  computed: {
    currentAdvertiser: get('common/advertiser'),
    allAccounts: get('common/accounts'),
    allFeatures: get('common/features'),
    currentUser: get('common/currentUser'),
    organizations: get('common/allOrganizations'),
    title() {
      return this.initialAdvertiser.id ? 'Edit Advertiser' : 'New Advertiser';
    },
    sortedVerticalOptions() {
      return this.verticalOptions;
    },
    sortedDspOptions() {
      return this.dsp;
    },
    error() {
      if (!isBlank(this.errorMsg)) {
        return this.errorMsg;
      }
      return null;
    },
    getAccounts() {
      if (this.isInternalAdmin) {
        return this.allAccounts;
      }
      return this.userAccounts;
    },
    allAdvertisers() {
      return this.allAccounts.flatMap((account) => account.advertisers || []);
    },
    /**
     * Filters advertisers on the current account selected
     */
    getAdvertisers() {
      // Find the account that matches this.accountData.name
      const matchingAccount = this.getAccounts.find(
        (account) => account.name === this.accountData.name
      );

      // If a matching account is found, filter its advertisers; otherwise, return an empty array
      return matchingAccount ? matchingAccount.advertisers : [];
    },
    matchingAdvertisers() {
      const advertisers = this.getAdvertisers;
      if (isBlank(advertisers) || !advertisers.length || isBlank(this.advertiser.name)) {
        return [];
      }
      return advertisers.filter(
        (advertiser) =>
          !isBlank(advertiser.name) &&
          advertiser.name.toLowerCase().includes(this.advertiser.name.toLowerCase())
      );
    },
    selectedFeatures() {
      if (!isBlank(this?.advertiser?.features)) {
        return this.allFeatures.filter((a) => this.advertiser.features.some((item) => item === a));
      }
      return [];
    },
    bothDspsEntered() {
      const xandr = this.advertiser?.dspMappings?.XANDR;
      const yahoo = this.advertiser?.dspMappings?.YAHOO;
      if (isBlank(xandr) || isBlank(yahoo)) return false;
      const hasDspError = this.errors.some(
        (item) => item.name === 'xandrId' || item.name === 'yahooId'
      );
      return !hasDspError;
    },
    isAuthorizedDspUser() {
      const userId = this.currentUser?.id;
      if (!userId) return false;
      return getAuthorizedDspUserList().includes(String(userId));
    },
  },
  watch: {
    allFeatures: {
      immediate: true,
      handler(newVal) {
        if (newVal && newVal.length > 0) {
          this.featuresListOptions = newVal;
        }
      },
    },
  },
  mounted() {
    this.loadFeatures();
    this.loadFlipPixels();
  },
  methods: {
    async loadFlipPixels() {
      this.advertiserPixelList = [];
      if (this.initialAdvertiser.id) {
        flipPixelApi
          .flipPixels(this.initialAdvertiser.id, buildQueryString({ showAll: true }))
          .then((pixels) => {
            if (pixels) {
              this.advertiserPixelList = pixels;
            }
          })
          .catch((err) => {
            if (window.$sentry) {
              if (err._reported !== true) {
                window.$sentry.captureException(err);
                err._reported = true;
              }
            }
          });
      }
    },
    async loadFeatures() {
      try {
        await loadAllFeatures(advertiserApi, this.$store);
      } catch (error) {
        console.error('Failed to load features:', error);
      }
    },
    onSelectFeatures(obj) {
      if (!this.advertiser.features) {
        this.advertiser.features = [];
      }
      const data = this.advertiser.features.filter((a) => obj.some((s) => a === s));
      obj.forEach((o) => {
        if (!data.some((s) => s === o)) {
          data.push(o);
        }
      });
      this.advertiser.features = data;
    },
    onVerticalSelect(vertical) {
      this.selectedVertical = vertical;
      this.isVerticalAlert = true;
    },
    onDspSelect(dps) {
      this.selectedDsp = dps;
      if (dps === null) {
        this.advertiser.xandrAdvertiserId = null;
      }
    },
    clearNameError() {
      this.errors = this.errors.filter((item) => item.name !== 'name');
      if (this.$refs.nameInput) this.$refs.nameInput.classList.remove('errorBox');
    },
    clearXandrIdError() {
      this.errors = this.errors.filter((item) => item.name !== 'xandrId');
      if (this.$refs.xandrIdInput) this.$refs.xandrIdInput.classList.remove('errorBox');
    },
    clearVerticalError() {
      this.isVerticalAlert = true;
    },
    clearDspMandatoryForPixelError() {
      this.errors = this.errors.filter((item) => item.name !== 'dspMandatoryForPixel');
    },
    clearYahooIdError() {
      this.errors = this.errors.filter((item) => item.name !== 'yahooId');
      if (this.$refs.yahooIdInput) this.$refs.yahooIdInput.classList.remove('errorBox');
    },
    validateName() {
      this.clearNameError();

      if (isBlank(this.advertiser.name)) {
        this.$refs.nameInput.focus();
        this.$refs.nameInput.classList.add('errorBox');
        const error = { name: 'name', message: 'Please enter advertiser name' };
        if (!this.errors.find((item) => item.name === 'name')) this.errors.push(error);
        return false;
      }

      const advertiserFoundWithSameName =
        !isBlank(this.getAdvertisers) &&
        this.getAdvertisers.some(
          (advertiser) =>
            !isBlank(advertiser.name) &&
            !isBlank(this.advertiser.name) &&
            advertiser.id !== this.advertiser.id &&
            advertiser.name.toUpperCase() === this.advertiser.name.toUpperCase()
        );

      if (advertiserFoundWithSameName) {
        const error = {
          name: 'name',
          message: `Advertiser already exists with ${this.advertiser.name} name`,
        };
        if (!this.errors.find((item) => item.name === 'name')) this.errors.push(error);
        return false;
      }

      return true;
    },

    /**
     * Validate Xandr DSP ID for an advertiser
     *
     * Rules:
     * 1. Value is optional ONLY if no pixels exist
     * 2. If provided, it must be a positive integer
     * 3. If pixels already exist, Xandr ID becomes mandatory
     * 4. ID must be unique across all advertisers
     */
    validateAdvertiserXandrId() {
      // Clear any existing Xandr-specific errors before validation
      this.clearXandrIdError();
      this.clearDspMandatoryForPixelError();

      // Read raw Xandr DSP ID from advertiser mappings
      const rawXid = this.advertiser?.dspMappings?.XANDR;

      // Normalize value:
      // - convert to string
      // - trim whitespace
      // - convert null/undefined to empty string
      const xid = rawXid === null || rawXid === undefined ? '' : String(rawXid).trim();

      const nan = xid !== '' && Number.isNaN(Number(xid)); // non-numeric value

      /**
       * Validation 1:
       * If Xandr ID is provided, it MUST be an integer
       * (no decimals, no strings like "12.5" or "abc")
       */
      if ((!isBlank(xid) && !Number.isInteger(Number(xid))) || nan) {
        // Focus input and apply error styling
        if (this.$refs.xandrIdInput) this.$refs.xandrIdInput.focus();
        if (this.$refs.xandrIdInput) this.$refs.xandrIdInput.classList.add('errorBox');

        // Push error only once
        const error = { name: 'xandrId', message: 'DSP ID must be an integer' };
        if (!this.errors.find((item) => item.name === 'xandrId')) {
          this.errors.push(error);
        }

        return false;
      }

      /**
       * Validation 3:
       * If Xandr ID is blank AND no pixels exist,
       * it is considered valid (optional case)
       */
      if (isBlank(xid)) {
        return true;
      }

      /**
       * Validation 4:
       * Explicitly reject:
       * - "0"
       * - NaN values
       * - Negative numbers (already covered by Validation 2, but good to be explicit here)
       */
      if (xid === '0' || Number.isNaN(Number(xid)) || Number(xid) <= 0) {
        if (this.$refs.xandrIdInput) this.$refs.xandrIdInput.focus();
        if (this.$refs.xandrIdInput) this.$refs.xandrIdInput.classList.add('errorBox');

        const error = { name: 'xandrId', message: 'Please enter a valid DSP ID' };
        if (!this.errors.find((item) => item.name === 'xandrId')) {
          this.errors.push(error);
        }

        return false;
      }

      /**
       * Validation 5:
       * Ensure Xandr ID is unique across all advertisers
       */
      const advertiserFoundWithSameXandrAdvertiserId =
        !isBlank(this.allAdvertisers) &&
        this.allAdvertisers.some((adv) => {
          // Ignore the advertiser currently being edited (if an ID is available)
          const candidate = adv?.dspMappings?.XANDR;
          if (adv?.id && this.advertiser?.id && adv.id === this.advertiser.id) return false;
          return !isBlank(candidate) && String(candidate) === xid;
        });

      if (advertiserFoundWithSameXandrAdvertiserId) {
        const error = {
          name: 'xandrId',
          message: `The ${xid} DSP ID has been assigned to another advertiser`,
        };
        if (!this.errors.find((item) => item.name === 'xandrId')) {
          this.errors.push(error);
        }
        return false;
      }

      // All validations passed
      return true;
    },

    /**
     * Validate Yahoo DSP ID for an advertiser
     *
     * Rules:
     * 1. Yahoo ID is always optional
     * 2. If provided, it must be a positive integer
     * 3. ID must be unique across all advertisers
     */
    validateAdvertiserYahooId() {
      // Clear any existing Yahoo-specific errors before validation
      this.clearYahooIdError();
      this.clearDspMandatoryForPixelError();

      // Read raw Yahoo DSP ID from advertiser mappings
      const rawYid = this.advertiser?.dspMappings?.YAHOO;

      // Normalize value (same approach as Xandr)
      const yid = rawYid === null || rawYid === undefined ? '' : String(rawYid).trim();

      /**
       * Validation 1:
       * If Yahoo ID is provided, it MUST be an integer
       */
      if (!isBlank(yid) && !Number.isInteger(Number(yid))) {
        if (this.$refs.yahooIdInput) this.$refs.yahooIdInput.focus();
        if (this.$refs.yahooIdInput) this.$refs.yahooIdInput.classList.add('errorBox');

        const error = { name: 'yahooId', message: 'DSP ID must be an integer' };
        if (!this.errors.find((item) => item.name === 'yahooId')) {
          this.errors.push(error);
        }

        return false;
      }

      /**
       * Validation 2:
       * Yahoo ID is optional, so blank value is valid
       */
      if (isBlank(yid)) {
        return true;
      }

      /**
       * Validation 3:
       * Reject invalid numeric values
       */
      if (yid === '0' || Number.isNaN(Number(yid)) || Number(yid) <= 0) {
        if (this.$refs.yahooIdInput) this.$refs.yahooIdInput.focus();
        if (this.$refs.yahooIdInput) this.$refs.yahooIdInput.classList.add('errorBox');

        const error = { name: 'yahooId', message: 'Please enter a valid DSP ID' };
        if (!this.errors.find((item) => item.name === 'yahooId')) {
          this.errors.push(error);
        }

        return false;
      }

      /**
       * Validation 4:
       * Ensure Yahoo ID is unique across all advertisers
       */
      const advertiserFoundWithSameYahooAdvertiserId =
        !isBlank(this.allAdvertisers) &&
        this.allAdvertisers.some((adv) => {
          // Ignore the advertiser currently being edited (if an ID is available)
          const candidate = adv?.dspMappings?.YAHOO;
          if (adv?.id && this.advertiser?.id && adv.id === this.advertiser.id) return false;
          return !isBlank(candidate) && String(candidate) === yid;
        });

      if (advertiserFoundWithSameYahooAdvertiserId) {
        const error = {
          name: 'yahooId',
          message: `The ${yid} DSP ID has been assigned to another advertiser`,
        };
        if (!this.errors.find((item) => item.name === 'yahooId')) {
          this.errors.push(error);
        }
        return false;
      }

      // All validations passed
      return true;
    },
    validateDspMandatoryForPixel() {
      this.clearDspMandatoryForPixelError();
      if (
        this.advertiserPixelList.length >= 1 &&
        !this.advertiser?.dspMappings?.XANDR &&
        !this.advertiser?.dspMappings?.YAHOO
      ) {
        const error = {
          name: 'dspMandatoryForPixel',
          message: 'At least one DSP is mandatory if advertiser has pixels',
        };
        if (!this.errors.find((item) => item.name === 'dspMandatoryForPixel')) {
          this.errors.push(error);
        }
        return false;
      }
      return true;
    },
    validateAdvertiserVerical() {
      this.clearVerticalError();
      if (isBlank(this.advertiser.vertical) || this.advertiser.vertical === null) {
        this.isVerticalAlert = false;

        const error = { name: 'vertical', message: 'Please select vertical' };
        if (!this.errors.find((item) => item.name === 'vertical')) this.errors.push(error);

        return false;
      }
      return true;
    },
    validateWebsite() {
      return true;
    },
    setCreateAccountOrg(val) {
      this.createAccountOrg = val.checked;
    },
    async createOrganization(newOrganizationName, isCreateOrg) {
      let createdOrg;
      try {
        createdOrg = await organizationApi.create({
          name: newOrganizationName,
          loginEnabled: isCreateOrg,
        });
        this.loadAllOrganizations(true);
      } catch (err) {
        const error = { name: 'updateError', message: 'Failed while adding the organization' };
        if (!this.errors.find((item) => item.name === 'updateError')) this.errors.push(error);
        if (window.$sentry) {
          if (err._reported !== true) {
            window.$sentry.captureException(err);
            err._reported = true;
          }
        }
      }
      return createdOrg;
    },
    async updateOrganization(currentOrganizationId, newOrganizationName, isCreateOrg) {
      let updatedOrg;
      try {
        updatedOrg = await organizationApi.update(currentOrganizationId, {
          name: newOrganizationName,
          loginEnabled: isCreateOrg,
        });
        this.loadAllOrganizations(true);
      } catch (err) {
        const error = { name: 'updateError', message: 'Failed while adding the organization' };
        if (!this.errors.find((item) => item.name === 'updateError')) this.errors.push(error);
        if (window.$sentry) {
          if (err._reported !== true) {
            window.$sentry.captureException(err);
            err._reported = true;
          }
        }
      }
      return updatedOrg;
    },
    async handleAdvertiser() {
      const dataValidated = this.validateData();
      if (!dataValidated) {
        return;
      }

      try {
        this.loading = true;
        if (!this.initialAdvertiser.id) {
          await this.addAdvertiser();
        } else {
          await this.updateAdvertiser();
        }
        this.clearSavedPath();
      } catch (err) {
        console.error('error handling advertiser ->', err);
      } finally {
        this.loading = false;
        if (isBlank(this.errors)) {
          this.close();
        }
      }
    },
    clearSavedPath() {
      const savedPath = localStorage.getItem('selectedPath');
      if (savedPath && savedPath.length > 0) {
        const { childOption } = JSON.parse(savedPath);
        if (childOption?.title === REACH_AND_FREQ_DASHBOARD.title) {
          localStorage.removeItem('selectedPath');
          localStorage.setItem('hardReloadFromAccSettings', true);
        }
      }
    },
    validateData() {
      this.clearNameError();
      this.clearXandrIdError();
      this.clearVerticalError();
      this.clearDspMandatoryForPixelError();
      this.clearYahooIdError();
      if (
        !this.validateName() ||
        !this.validateAdvertiserXandrId() ||
        !this.validateAdvertiserVerical() ||
        !this.validateAdvertiserYahooId() ||
        !this.validateDspMandatoryForPixel()
      ) {
        return false;
      }
      this.errors = [];
      return true;
    },
    async addAdvertiser() {
      this.advertiser.name = this.advertiser.name.trim();
      const advertiser = JSON.parse(JSON.stringify(this.advertiser));
      advertiser.name = advertiser.name.trim();
      advertiser.accountId = this.accountData.id;
      try {
        // Create organizationId for Advertiser
        const createdAdvertiserOrg = await this.createOrganization(
          advertiser.name,
          this.createAccountOrg
        );
        advertiser.organizationId = createdAdvertiserOrg.id;
        await advertiserApi.createAdvertiser(advertiser);
        this.loadUserAccounts(this.currentUser.id, true);
      } catch (err) {
        const error = { name: 'updateError', message: 'Failed while adding the advertiser' };
        if (!this.errors.find((item) => item.name === 'updateError')) this.errors.push(error);
        if (window.$sentry) {
          if (err._reported !== true) {
            window.$sentry.captureException(err);
            err._reported = true;
          }
        }
      }
    },
    async updateAdvertiser() {
      this.advertiser.name = this.advertiser.name.trim();
      const advertiser = JSON.parse(JSON.stringify(this.advertiser));
      advertiser.name = advertiser.name.trim();
      if (isEqual(this.initialAdvertiser, this.advertiser)) {
        return;
      }
      try {
        this.$emit('update:advertiserLoading', true);
        await advertiserApi.editAdvertiser(this.initialAdvertiser.id, advertiser);
        // update advertiser in store to reflect changes, specifically for features
        if (this?.currentAdvertiser?.id === advertiser?.id) {
          this.$store.set('common/advertiser', advertiser);
        }
        this.loadUserAccounts(this.currentUser.id, true);
      } catch (err) {
        const error = { name: 'updateError', message: 'Failed while updating the advertiser' };
        if (!this.errors.find((item) => item.name === 'updateError')) this.errors.push(error);
        if (window.$sentry) {
          if (err._reported !== true) {
            window.$sentry.captureException(err);
            err._reported = true;
          }
        }
      }
    },

    close() {
      this.$emit('close');
    },

    getErrors(fieldName) {
      const errSet = new Set(this.errors);
      const errArr = Array.from(errSet);
      const errItem = errArr.find((item) => item.name === fieldName);
      if (errItem) {
        const idElement = document.getElementById('errorContainer');
        if (idElement) {
          idElement.style.display = 'block';
        }
        const errMessage = errItem.message ? errItem.message : null;
        return errMessage;
      }
      return null;
    },
    setCustomReportsEnabled(val) {
      this.advertiser.customReportsEnabled = val.checked;
    },
    setHideCostMetrics(val) {
      this.advertiser.hideCostMetrics = val.checked;
    },
    setDefaultDsp(value) {
      this.advertiser.dsp = value;
    },
  },
};
</script>

<style lang="scss" scoped>
::v-deep .modal-mask {
  .modal-container {
    background-color: #212429;
    min-height: 130px;
  }
  .modal-wrapper {
    margin: 0 auto;
  }
}
/**custom */
.list-box {
  position: relative;
  z-index: 2;
  color: #fff;
  background-color: #212429;
  border-radius: 0;
  padding: 30px 20px;
  width: 100%;
  display: block;
  min-width: 800px;
  max-width: 800px;
  margin: 0 auto;
  ul {
    margin-bottom: 10px;
    ul {
      border: 0;
      margin: 0;
    }
    li {
      font-size: 12px;
      line-height: 0.75rem;
      color: rgba(130, 130, 140, 0.8);
      padding-bottom: 5px;
      padding-top: 5px;
      margin-bottom: 0;
      position: relative;

      li {
        border-bottom: 1px solid rgba(170, 170, 170, 0.1);
        padding: 15px 15px 15px 10px;
        list-style: none;
        list-style-position: inside;
        font-size: 13px;
        a {
          color: #848890;
        }
        .box {
          svg {
            color: #848890;
            &:hover {
              color: var(--adminprimarycolor) !important;
            }
          }
        }
      }
      a {
        color: #cad1d6;
        display: inline;
        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
  .button-box {
    position: absolute;
    top: 5px;
    right: 0;
    line-height: 30px;
    .box {
      display: inline-block;
      margin-left: 10px;
    }
  }
}
.modal-wrapper-box {
  width: 100%;
  min-width: 500px;
  max-width: 650px;
  padding: 15px;
  margin: 0 auto;
  color: #666;
  background-color: #212429;
  font-size: 12px;
  line-height: 0.75rem;
  color: rgba(130, 130, 140, 0.8);
  .modal-header {
    margin-bottom: 10px;
    h2 {
      text-align: center;
      color: #fff;
      line-height: 1.3;
      padding-bottom: 10px;
    }
    p {
      border-top: 2px solid white;
      text-align: center;
      font-size: 18px;
      padding: 20px 0;
      margin: 0;
      color: #fff;
    }
  }
  .modal-body {
    width: 600px;
  }
  .form-group {
    margin-bottom: 15px;
    overflow: hidden;
    position: relative;
    color: #fff;
    .add-btn {
      position: absolute;
      right: 0;
      top: 0;
      color: #cad1d6;
      border: none;
      background-color: var(--adminprimarycolor);
      font-size: 16px;
      padding: 14px;
      border-radius: 0 4px 4px 0;
      line-height: 12px;
    }
    .list-url {
      clear: both;
      width: 80%;
      line-height: 25px;
      float: right;
      font-size: 13px;
      margin-top: -6px;
      min-height: 15px;
      color: #848890;
      margin-left: 120px;
      p {
        text-align: left;
      }
      a {
        display: inline;
        color: #848890;
      }
      span {
        font-size: 10px;
        top: -6px;
        color: #ff0202;
        left: 3px;
        position: relative;
      }
    }
    label {
      width: 20%;
      display: inline-block;
      font-size: 0.875rem;
      color: #cad1d6;
      letter-spacing: 0.07em;
      float: left;
      padding: 9px;
      line-height: 20px;
    }
    input {
      width: 80%;
      float: left;
      height: 30px;
      font-size: 0.875rem;
      display: block;
      min-height: 40px;
      padding: 8px 10px;
      color: #cad1d6;
      background-color: #323239;
      cursor: pointer;
      border-radius: 4px;
      border: 1px solid rgba(170, 170, 170, 0.1);
      &:hover {
        border: 1px solid var(--adminprimarycolor);
      }
    }
    select {
      width: 80%;
      float: left;
      height: 30px;
      font-size: 14px;
      color: #cad1d6;
      display: block;
      min-height: 40px;
      padding: 8px 10px;
      text-transform: capitalize;
      cursor: pointer;
      background-color: transparent;
      border: 1px solid rgba(170, 170, 170, 0.1);
      border-radius: 4px;
    }
    input[type='checkbox'] {
      width: auto;
      background-color: #323239;
      color: #cad1d6;
      &::before,
      &::after {
        background-color: #323239;
        color: #cad1d6;
      }
    }
    textarea {
      width: 80%;
      float: left;
      font-size: 0.875rem;
      display: block;
      min-height: 40px;
      padding: 8px 10px;
      color: #cad1d6;
      background-color: #323239;
      cursor: pointer;
      border-radius: 4px;
      height: 100px;
      resize: none;
      border: 1px solid rgba(170, 170, 170, 0.1);
      &:hover {
        border: 1px solid var(--adminprimarycolor);
      }
    }
    button {
      padding: 5px;
      font-size: 16px;
      margin-left: 10px;
      float: right;
    }
  }
}
.top-li {
  .button-box {
    top: 0;
  }
  a {
    svg {
      font-size: 19px;
      color: #ddd;
      &:hover {
        color: var(--adminprimarycolor) !important;
      }
    }
  }
}
.sub-li {
  padding: 10px 10px 10px 0;
  margin-top: 15px;
  // height: 30px;
  .button-box {
    top: -2px;
  }
  a {
    font-size: 14px;
    svg {
      font-size: 14px;
      color: #cad1d6;
      &:hover {
        color: var(--adminprimarycolor) !important;
      }
    }
  }
}
a {
  svg {
    color: #fff;
    &:hover {
      color: var(--adminprimarycolor) !important;
    }
  }
}
.com-title {
  display: inline-block;
  font-size: 15px;
  font-weight: 400;
  line-height: 1.1em;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #fff;
  margin-bottom: 20px;
}
.actions-btn {
  margin-bottom: 20px;
}
.mr-20 {
  margin-right: 20px;
}
::v-deep .k-btn {
  display: inline-block;
  min-width: 75px;
  font-weight: 600;
  color: #303335 !important;
  text-transform: uppercase;
  letter-spacing: 0.07em;
  background-color: var(--adminprimarycolor);
  border-radius: 3px;
  appearance: none;
}
::v-deep .k-btn.btn-size-3 span.label {
  padding: 9px 19px;
  line-height: 20px;
  color: var(--adminovertext);
}
::v-deep .k-btn:hover {
  color: #cad1d6 !important;
  background-color: #424242 !important;
}
.line-hr {
}
.sm {
  font-size: 13px;
  font-weight: 600;
  font-style: italic;
  border-top: 1px solid var(--adminprimarycolor);
  padding: 10px 0 20px 0;
  width: 100%;
  text-align: left;
  color: #fff;
  margin-top: -20px;
}
tr.no-bg {
  line-height: 80px;
  &:hover {
    background-color: transparent !important;
  }
  input {
    width: 95% !important;
  }
  td {
    text-align: right;
    padding: 0 36px 0 8px;
  }
}
.mg-tp-20 {
  margin-top: 20px;
}
tr.no-bg-no-pg {
  line-height: 40px;
  &:hover {
    background-color: transparent !important;
  }
  input {
    width: 95% !important;
  }
  td {
    text-align: right;
    padding: 0 0 0 8px;
  }
}
td a {
  display: inline-block;
  margin-right: 8px;
}
.col-lh-40 {
  line-height: 40px;
  display: inline;
}
tr.no-bg-axnbtn {
  overflow: hidden;
  &:hover {
    background-color: transparent !important;
  }
  input {
    width: 95% !important;
  }
  td {
    text-align: right;
    padding: 0 36px 0 8px;
  }
}
.display-only {
  display: inline-block;
  top: 5px;
  clear: none;
  margin-left: 0;
}

.advertiser-matches {
  width: 80%;
  background-color: #555555;
  max-height: 130px;
  overflow: hidden auto;
}
.advertiser-matches ul li {
  padding: 3px 10px;
  text-align: start;
}
.advertiser-matches ul li:hover {
  background-color: #444444;
}

.lg-control-box {
  display: inline-flex;
  width: 100%;

  label {
    width: 24% !important;
    padding: 9px 7px !important;
  }
}
/* --- DSP ID Row Styles --- */
.dsp-row-override {
  display: block;
}
.dsp-row-override .dsp-fields-container {
  width: 80%;
  float: left;
  display: flex;
  align-items: center;
}
.dsp-row-override .dsp-fields-container .dsp-input {
  flex: 1;
  width: auto;
}
.dsp-row-override .dsp-fields-container .yahoo-inline-label {
  width: auto;
  float: none;
  padding: 0 15px;
  white-space: nowrap;
  margin: 0;
  line-height: normal;
}
.dsp-error-container {
  min-height: 38px;
  width: 100%;
}

/* --- Default DSP Toggle Styles --- */
.dsp-auth-error {
  text-align: left;
  margin-bottom: 15px;
}
.dsp-toggle-group {
  display: block;
}
.dsp-toggle-group .toggle-container-wrapper {
  width: 80%;
  float: left;
  display: flex;
  align-items: center;
}
.toggle-container {
  display: flex;
  width: 55%;
  height: 40px;
}
.toggle-btn {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #323239;
  color: #cad1d6;
  font-size: 14px;
  cursor: pointer;
  border: 1px solid rgba(170, 170, 170, 0.1);
  transition: all 0.2s ease-in-out;
}
.toggle-btn:first-child {
  border-radius: 4px 0 0 4px;
}
.toggle-btn:nth-child(2) {
  border-radius: 0 4px 4px 0;
  border-left: none;
}
.toggle-btn.active {
  background-color: #3b5a7a;
  color: #ffffff;
  border-color: #3b5a7a;
  font-weight: 600;
}
</style>
